// Modules
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { environment } from "../environments/environment";
import { RoutesModule } from "./app-routing.module";
import { PromoModule } from "./promo/promo.module";
import { MenuModule } from "./menu/menu.module";
import { AdminModule } from "./admin/admin.module";
import { EventReservationsModule } from "./event-reservations/event-reservations.module";
import { FiestaClubModule } from "./fiesta-club/fiesta-club.module";
import { SlickModule } from "ngx-slick";
import { MobileAppModule } from './mobile-app/mobile-app.module';

import { BajaFiestaModule } from './baja-fiesta/baja-fiesta.module';
import { FiestaDeLasMadresModule } from './fiesta-de-las-madres/fiesta-de-las-madres.module';
import { DadsAndGradsModule } from './dads-and-grads/dads-and-grads.module';
import { TacoTuesdaysModule } from './taco-tuesdays/taco-tuesdays.module';
import { Anniversary52ndModule } from './anniversary-52nd/anniversary-52nd.module';
import { MargaritaFlightsModule } from './margarita-flights/margarita-flights.module';

// Should be modules...
import { KidsEatFreeMondaysComponent } from './kids-eat-free-mondays/kids-eat-free-mondays.component';
import { HispanicHeritageMonthComponent } from './hispanic-heritage-month/hispanic-heritage-month.component';
import { FundraisingProgramComponent } from './fundraising-program/fundraising-program.component';
import { StarAchieversComponent } from './star-achievers/star-achievers.component';
import { NationalQuesadillaDayComponent } from './national-quesadilla-day/national-quesadilla-day.component';
import { NationalCoffeeDayComponent } from './national-coffee-day/national-coffee-day.component';
import { NationalTacoDayComponent } from './national-taco-day/national-taco-day.component';
import { DiaDeLosMuertosComponent } from './dia-de-los-muertos/dia-de-los-muertos.component';
import { HalloweenWeekComponent } from './halloween-week/halloween-week.component';
import { HolidaySeasonComponent } from './holiday-season/holiday-season.component';
import { JobsAnaheimHillsComponent } from './jobs-anaheim-hills/jobs-anaheim-hills.component';
import { HolidayBonusCardComponent } from './holiday-bonus-card/holiday-bonus-card.component';

// Components
import { AppComponent } from "./app.component";
import { MainNavComponent } from "./shared/main-nav/main-nav.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { MenuComponent } from "./menu/menu.component";
import { MenuSidebarComponent } from "./menu/menu-sidebar/menu-sidebar.component";
import { LandingComponent } from "./landing/landing.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { BagComponent } from "./bag/bag/bag.component";
import { LocationsMapComponent } from "./landing/locations-map/locations-map.component";
import { EditOrderComponent } from "./edit-order/edit-order.component";
import { LoginComponent } from "./admin/login/login/login.component";
import { OnlineOrderingModalComponent } from "./online-ordering-modal/online-ordering.component";
import { ReservationsComponent } from './reservations/reservations.component';
import { RestaurantWeekComponent } from './restaurant-week/restaurant-week.component';

//Services
import { LocationsService } from "./services/locations/locations.service";
import { OrderService } from "./services/order/order.service";
import { PromosService } from "./services/promos/promos.service";
import { MenuService } from "./services/menu/menu.service";
import { PricingService } from "./services/pricing/pricing.service";
import { ItemDescriptionsService } from "./services/item-descriptions/item-descriptions.service";

// Store
import { MenuStore } from "./store/menu/menu.store";
import { ModifiersService } from "./services/modifiers/modifiers.service";
import { UserAuthService } from "./services/user-auth/user-auth.service";
import { PaymentService } from "./services/payment/payment.service";

@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent,
    FooterComponent,
    LandingComponent,
    LoginComponent,
    NotFoundComponent,
    BagComponent,
    LocationsMapComponent,
    EditOrderComponent,
    OnlineOrderingModalComponent,
    KidsEatFreeMondaysComponent,
    HispanicHeritageMonthComponent,
    FundraisingProgramComponent,
    StarAchieversComponent,
    NationalQuesadillaDayComponent,
    NationalCoffeeDayComponent,
    NationalTacoDayComponent,
    DiaDeLosMuertosComponent,
    HalloweenWeekComponent,
    HolidaySeasonComponent,
    ReservationsComponent,
    JobsAnaheimHillsComponent,
    HolidayBonusCardComponent,
    RestaurantWeekComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "rodrigos" }),
    EventReservationsModule,
    RoutesModule,
    HttpClientModule,
    PromoModule,
    FormsModule,
    ReactiveFormsModule,
    MenuModule,
    BrowserAnimationsModule,
    FiestaClubModule,
    MobileAppModule,
    BajaFiestaModule,
    FiestaDeLasMadresModule,
    DadsAndGradsModule,
    TacoTuesdaysModule,
    Anniversary52ndModule,
    SlickModule.forRoot(),
    MargaritaFlightsModule
  ],
  providers: [
    LocationsService,
    OrderService,
    PromosService,
    UserAuthService,
    MenuService,
    PricingService,
    MenuStore,
    ItemDescriptionsService,
    ModifiersService,
    PaymentService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts